/* Lumaro — plexus "pocket" behind the hero case.
   Same visual vocabulary as lux-plexus.js (drifting points, links between
   near neighbours), but scoped to its own canvas inside the hero stage and
   confined to a disc by the CSS radial mask on .lux-case__plexus. Lower
   density than the full-page field, since it sits directly behind the
   product and must stay texture, never pattern.
   Pauses when off-screen or when the tab is hidden. */
(function () {
  var canvas = document.querySelector('[data-lux-orb]');
  if (!canvas) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ctx = canvas.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var W = 0, H = 0, pts = [], linkDist = 96, count = 26;
  var raf = null, running = false;

  // Cursor is tracked in viewport coordinates and converted to canvas-local
  // ones through a cached rect. The canvas is pointer-events:none, so the
  // listener has to live on the window; re-reading the rect every frame would
  // force a layout on each tick, hence the cache refreshed on resize/scroll.
  var mouse = { x: -9999, y: -9999 };
  var rect = null;

  function measure() {
    rect = canvas.getBoundingClientRect();
  }

  function resize() {
    measure();
    if (!rect || !rect.width) return;
    W = rect.width;
    H = rect.height;
    canvas.width = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    linkDist = Math.max(78, Math.min(120, W / 4.6));
    count = Math.max(16, Math.min(34, Math.round((W * H) / 9000)));
    seed();
  }

  function seed() {
    pts = [];
    for (var i = 0; i < count; i++) {
      pts.push({
        x: Math.random() * W,
        y: Math.random() * H,
        vx: (Math.random() - 0.5) * 0.2,
        vy: (Math.random() - 0.5) * 0.2,
        r: Math.random() * 1.3 + 0.8
      });
    }
  }

  function step() {
    ctx.clearRect(0, 0, W, H);

    var mx = -9999, my = -9999;
    if (rect && mouse.x > -9998) {
      mx = mouse.x - rect.left;
      my = mouse.y - rect.top;
    }
    var mDist = linkDist * 1.6;

    for (var i = 0; i < pts.length; i++) {
      var p = pts[i];
      p.x += p.vx;
      p.y += p.vy;
      if (p.x < -16) p.x = W + 16; else if (p.x > W + 16) p.x = -16;
      if (p.y < -16) p.y = H + 16; else if (p.y > H + 16) p.y = -16;
    }

    for (var a = 0; a < pts.length; a++) {
      var pa = pts[a];
      for (var b = a + 1; b < pts.length; b++) {
        var pb = pts[b];
        var dx = pa.x - pb.x, dy = pa.y - pb.y;
        var d = Math.sqrt(dx * dx + dy * dy);
        if (d < linkDist) {
          ctx.strokeStyle = 'rgba(168,85,247,' + (1 - d / linkDist) * 0.32 + ')';
          ctx.lineWidth = 1;
          ctx.beginPath();
          ctx.moveTo(pa.x, pa.y);
          ctx.lineTo(pb.x, pb.y);
          ctx.stroke();
        }
      }

      // link toward the cursor, same as the full-page field
      var mdx = pa.x - mx, mdy = pa.y - my;
      var md = Math.sqrt(mdx * mdx + mdy * mdy);
      if (md < mDist) {
        ctx.strokeStyle = 'rgba(216,180,254,' + (1 - md / mDist) * 0.4 + ')';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(pa.x, pa.y);
        ctx.lineTo(mx, my);
        ctx.stroke();
      }
    }

    for (var k = 0; k < pts.length; k++) {
      var pp = pts[k];
      ctx.beginPath();
      ctx.fillStyle = 'rgba(221,199,255,0.72)';
      ctx.arc(pp.x, pp.y, pp.r, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  function loop() {
    step();
    raf = requestAnimationFrame(loop);
  }
  function play() {
    if (running || reduce) return;
    running = true;
    loop();
  }
  function stop() {
    running = false;
    if (raf) cancelAnimationFrame(raf);
    raf = null;
  }

  function start() {
    resize();
    canvas.classList.add('is-in');
    if (reduce) step(); else play();

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(resize, 200);
    });
    window.addEventListener('scroll', measure, { passive: true });

    window.addEventListener('mousemove', function (e) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
    }, { passive: true });
    window.addEventListener('mouseout', function () {
      mouse.x = -9999;
      mouse.y = -9999;
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else play();
    });

    // No reason to burn frames once the hero has scrolled away.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) play(); else stop();
        });
      }, { threshold: 0 }).observe(canvas);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
